import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { Image } from 'components';
import { useMenu } from 'hooks';
import { removeUnderscoresAndCapitalize } from 'lib/utils';

const UserItem = ({
	user,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(user, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(user, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(user.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(user)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected}
						onChange={() => handleSelect(user)}
						name="user"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Image src={user.avatar_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Typography variant="body2" color="text.primary">
					{user.first_name}
				</Typography>
			</TableCell>
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Typography variant="body2" color="text.primary">
					{user.last_name}
				</Typography>
			</TableCell>
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Typography variant="body2" color="text.primary">
					{user.email}
				</Typography>
			</TableCell>
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Typography variant="body2" color="text.primary">
					{removeUnderscoresAndCapitalize(user.role)}
				</Typography>
			</TableCell>
			<TableCell align="left" sx={{ pl: 3, pr: 3 }}>
				<Typography
					variant="body2"
					color={user.paid ? 'success.main' : 'text.secondary'}
				>
					{user.paid ? 'Yes' : '-'}
				</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default UserItem;
